import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
   <>
   <footer className="footer">
  <div className="container">
    <div className="footer-top">
 
      {/* Col 1 — Logo + desc */}
      <div className="footer-brand">
        <div className="footer-logo">
          <img src="/Images/logo.png" alt="Save Hornbills" className="footer-logo-img" />
        </div>
        <p className="footer-desc">
          A conservation initiative working to protect Africa's most
          endangered birds through science, community, and advocacy.
        </p>
       
      </div>
 
      {/* Col 2 — Species */}
      <div className="footer-col">
        <div className="footer-col-title">SPECIES</div>
        <ul className="footer-links">
          <li><Link to="/southern-grounded-hornbill">Southern Ground Hornbill</Link></li>
          <li><Link to="/african-penguin">African Penguin</Link></li>
          <li><Link to="/bearded-vulture">Bearded Vulture</Link></li>
          <li><Link to="/pels-fishing-owl">Pel's Fishing Owl</Link></li>
          <li><Link to="/cape-gannet">Cape Gannet</Link></li>
          <li><Link to="/saddle-billed-stork">Saddle-billed Stork</Link></li>
        </ul>
      </div>
 
      {/* Col 3 — Organization */}
      <div className="footer-col">
        <div className="footer-col-title">ORGANIZATION</div>
        <ul className="footer-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/solution">Solutions</Link></li>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/donate">Donate</Link></li>
        </ul>
      </div>
 
      {/* Col 4 — Contact */}
      <div className="footer-col">
        <div className="footer-col-title">CONTACT</div>
        <ul className="footer-links">
          <li><a href="mailto:info@savehornbills.com">info@savehornbills.com</a></li>
          <li><a href="tel:+12025550187">+1 720 212 1307</a></li>
          <li className="footer-address">
            Address: 2524 Bailey Ln, <br />
           Lafayette, CO 80020
          </li>
        </ul>
      </div>
 
    </div>
 
    {/* Bottom bar */}
    <div className="footer-bottom">
      <p className="footer-copyright">
        © 2026 SAVEHORNBILLS LLC. ALL RIGHTS RESERVED.
      </p>
      <div className="footer-legal">
        <Link to="/privacy-policy">PRIVACY POLICY</Link>
        <Link to="/terms-of-service">TERMS OF SERVICE</Link>
      </div>
    </div>
 
  </div>
</footer>
   </>
  )
}

export default Footer